import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { API_URL } from "../../../../config";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

const BreathingBehaviorsForm = ({selectedFormId,data,shouldPrint,selectedClientDetails}) => {
  const { t } = useTranslation();
  const initialFormData = {
    name: selectedClientDetails ? `${selectedClientDetails.firstname} ${selectedClientDetails.lastname}` : "",
    date: "",
    email: "",
    tel: "",
    sex: "",
    age: "",
    primaryHealthIssue: "",
    breathingIssue: "",
    breathingQuestions: Array(14).fill(""),
    symptomResponses: Array(14).fill({ yesNo: null, frequency: null, situations: "", comment: "" }),
    generalComments: "",
  }
  const [formData, setFormData] = useState(data?data:initialFormData);

  // Symptoms array with IDs
  const symptoms = [
    { id: 1, text: "Chest tightness, pressure, or pain" },
    { id: 2, text: "Intentional breathing, purposeful regulation" },
    { id: 3, text: "Dizziness, light-headedness, fainting" },
    { id: 4, text: "Shortness of breath, difficulty breathing" },
    { id: 5, text: "Tingling or numbness, e.g., fingers, lips" },
    { id: 6, text: "Unable to breathe deeply" },
    { id: 7, text: "Not exhaling completely, aborting the exhale" },
    { id: 8, text: "Deep breathing, like during talking" },
    { id: 9, text: "Chest breathing, effortful breathing" },
    { id: 10, text: "Breath holding, irregular breathing" },
    { id: 11, text: "Rapid breathing, panicky breathing" },
    { id: 12, text: "Worried about my breathing" },
    { id: 13, text: "Mouth breathing" },
    { id: 14, text: "Can't seem to get enough oxygen" },
  ];

  // Situations array with IDs
  const situations = [
    { id: 1, text: "(01) working (employment)" },
    { id: 2, text: "(02) resting (between tasks)" },
    { id: 3, text: "(03) performing (e.g., test taking)" },
    { id: 4, text: "(04) feeling anxious or worried" },
    { id: 5, text: "(05) feeling tired or stressed" },
    { id: 6, text: "(06) interacting in groups" },
    { id: 7, text: "(07) traveling, unfamiliar places" },
    { id: 8, text: "(08) socializing, meeting people" },
    { id: 9, text: "(09) feeling angry or upset" },
    { id: 10, text: "(10) intimacy, expressing feelings" },
    { id: 11, text: "(11) physical discomfort, pain" },
    { id: 12, text: "(12) going to sleep, while asleep" },
    { id: 13, text: "(13) learning new tasks, new info" },
    { id: 14, text: "(14) feeling unsure of self" },
    { id: 15, text: "(15) allergens, weather, foods" },
  ];

  // Breathing questions array with IDs
  const breathingQuestions = [
    { id: 1, text: "Issues related to breathing?" },
    { id: 2, text: "Episodes of not being able to get enough air?" },
    { id: 3, text: "Respiratory disorders?" },
    { id: 4, text: "Physical injuries: e.g., back, chest, neck?" },
    { id: 5, text: "Emotional issues: e.g., panic, anxiety, anger?" },
    { id: 6, text: "Life traumas: e.g., PTSD, emotional abuse, chronic stress?" },
    { id: 7, text: "Pain issues: past or present, acute or chronic?" },
    { id: 8, text: "Physical limitations: e.g., fatigue, speech, movement?" },
    { id: 9, text: "Deficiencies: e.g., electrolytes (kidney problems)?" },
    { id: 10, text: "Social challenges: e.g., relationships, family?" },
    { id: 11, text: "Work related challenges: e.g., co-workers, supervisor?" },
    { id: 12, text: "Learning issues, e.g., attention, memory, focus?" },
    { id: 13, text: "Performance issues: e.g., speaking, technology, testing" },
    { id: 14, text: "Current prescriptions?" },
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleBreathingQuestionChange = (index, value) => {
    const updated = [...formData.breathingQuestions];
    updated[index] = value;
    setFormData((prev) => ({ ...prev, breathingQuestions: updated }));
  };

  const handleSymptomChange = (index, field, value) => {
    const updated = [...formData.symptomResponses];
    updated[index] = { ...updated[index], [field]: value };
    setFormData((prev) => ({ ...prev, symptomResponses: updated }));
  };
 const [successModal, setsuccessModal] = useState(false);
    const successToggleModal = () => setsuccessModal(!successModal);
  const [loading, setLoading] = useState(false);

const handleSubmit = () => {
  const userId = localStorage.getItem("user_id");
  const selectedClient = localStorage.getItem("selectedClient");
  const accessToken = localStorage.getItem("accessToken");

  const client_id = selectedClient === "null" ? userId : selectedClient;

  // Start loader
  setLoading(true);



  // Prepare payload (no need to stringify form_data here)
  const payload = {
    client_id: client_id,
    form_id: selectedFormId, // Ensure this variable is defined
    form_data: JSON.stringify(formData),
  };

  console.log("📤 Sending form payload test:", payload);

  fetch(API_URL + "/forms/client/form-submit", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": accessToken,
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((resp) => {
      console.log("✅ Response:", resp);
      if (resp.status) {
        successToggleModal();
        setFormData(initialFormData);
      } else {
        console.error("❌ Upload failed:", resp.message);
        console.log("Upload failed: " + resp.message);
      }
    })
    .catch((err) => {
      console.error("⚠️ Error submitting form:", err);
      console.log("Something went wrong while submitting the form.");
    })
    .finally(() => {
      setLoading(false);
    });
};

  return (
    <div style={{ fontFamily: "Arial, sans-serif", maxWidth: "1200px",  margin: !data ? "20px auto" : "auto", padding: "10px", border: !data && "1px solid #ccc", marginTop: "20px" }}>
      <h1
        style={{
          color: "#cc0000",
          textAlign: "center",
          margin: "10px 0",
          fontSize: "20px",
          fontWeight: "bold",
        }}
      >
        YOUR BREATHING BEHAVIORS
      </h1>
       <p
        style={{
          margin: "10px 0",
          fontSize: "14px",
          lineHeight: "1.4",
        }}
      >
        <strong>Everyone has breathing habits.</strong> Most people are NOT
        aware of their breathing habits and how they may be interacting with
        other complaints, symptoms, and deficits. This checklist has been
        designed to serve as a "guideline" for assisting you in exploring
        whether or not your breathing habits are consistent with optimal
        respiration, and if not, how they may be affecting you at specific times
        and places.
      </p>

      {/* Personal Info */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", margin: "15px 0" }}>
        {[
          { label: "Name", name: "name", width: 300 },
          { label: "Date", name: "date", width: 190 },
          { label: "Email", name: "email", width: 270 },
          { label: "Tel", name: "tel", width: 170 },
          { label: "Sex", name: "sex", width: 50 },
          { label: "Age", name: "age", width: 50 },
          { label: "Primary health issue?", name: "primaryHealthIssue", width: 370 },
        ].map((field) => (
          <div key={field.name} style={{ display: "flex", alignItems: "flex-end" }}>
            <label style={{ fontWeight: "bold", marginRight: "5px" }}>{field.label}</label>
            <input
              type="text"
              name={field.name}
              disabled={field.name==="name" && Boolean(selectedClientDetails)}
              value={formData[field.name]}
              onChange={handleInputChange}
              style={{ borderBottom: "1px solid black", borderTop: "none", borderLeft: "none", borderRight: "none", width: field.width, height: 30, outline: "none", backgroundColor: "#f1f4ff" }}
            />
          </div>
        ))}
      </div>

      {/* Breathing Issue */}
      <div style={{ display: "flex", alignItems: "center", margin: "15px 0" }}>
        <label style={{ fontWeight: "bold", marginRight: "5px" }}>Is there a breathing issue?</label>
        <input
          type="text"
          name="breathingIssue"
          value={formData.breathingIssue}
          onChange={handleInputChange}
          style={{ borderBottom: "1px solid black", borderTop: "none", borderLeft: "none", borderRight: "none", width: 370, height: 30, outline: "none", backgroundColor: "#f1f4ff" }}
        />
      </div>
  <p
        style={{
          fontWeight: "bold",
          margin: "15px 0 5px",
        }}
      >
        Answers to the following questions are important to learning about the
        possible origins of your breathing habits.
      </p>
      {/* Breathing Questions */}
     {breathingQuestions.map((question, index) => (
  <div
    key={question.id}
    style={{ display: "flex", margin: "5px 0", alignItems: "center",gap:data && "15px"}}
  >
    {/* Checkboxes for YES / NO */}
    <div style={{ display: "flex", alignItems: "center", width: 100 }}>
      <input
        type="checkbox"
        checked={formData.breathingQuestions[index] === "YES"}
        onChange={() =>
          handleBreathingQuestionChange(
            index,
            formData.breathingQuestions[index] === "YES" ? "" : "YES"
          )
        }
        style={{ marginRight: 5,marginTop:0 }}
      />
      <span style={{ marginRight: 10 }}>Yes</span>

      <input
        type="checkbox"
        checked={formData.breathingQuestions[index] === "NO"}
        onChange={() =>
          handleBreathingQuestionChange(
            index,
            formData.breathingQuestions[index] === "NO" ? "" : "NO"
          )
        }
        style={{ marginRight: 5,marginTop:0 }}
      />
      <span>No</span>
    </div>

    {/* Question text and input */}
    <div style={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
      <span style={{ marginRight: 10 }}>{question.text}</span>
      <input
        type="text"
        value={formData.breathingQuestions[index]}
        onChange={(e) =>
          handleBreathingQuestionChange(index, e.target.value)
        }
        style={{
          borderBottom: "1px solid black",
          borderTop: "none",
          borderLeft: "none",
          borderRight: "none",
          flexGrow: !data && 1,
          height: 30,
          outline: "none",
          backgroundColor: "#f1f4ff",
        }}
      />
    </div>
  </div>
))}


      {/* Symptoms Table */}
      <div style={{ marginTop: 20 }}>
       <p style={{ fontWeight: "bold" }}>
          Do you ever experience any of the 14 symptoms listed below? Check the
          Y column for "YES," OR the N column for "NO," after each symptom
          listed. If you checked YES, indicate{" "}
          <span style={{ fontStyle: "italic", textDecoration: "underline" }}>
            how frequently you experience the symptom
          </span>{" "}
          by checking a number 1 through 7, where 1 is rarely and 7 is every
          day. Then enter in the{" "}
          <span style={{ fontStyle: "italic", textDecoration: "underline" }}>
            situations in which you experience a symptom
          </span>
          , in the "situation column," by entering a number that corresponds to
          one of the 15 situations listed at the bottom of the page. If the
          situation is not shown on the list, write it on the "comment" column.
          Focus on when, where, and with whom these symptoms may occur.
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            margin: "10px 0",
            fontSize: "12px",
          }}
        >
          <span>
            How often? 1 = rarely ............................ 7 = every day
          </span>
        </div>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
          <thead style={{ backgroundColor: "#f3f3f3" }}>
            <tr>
              <th style={{ border: "1px solid black", padding: 5, textAlign: "left" }}>Symptom</th>
              <th style={{ border: "1px solid black", padding: 5, textAlign: "center" }}>N</th>
              <th style={{ border: "1px solid black", padding: 5, textAlign: "center" }}>Y</th>
              {[1,2,3,4,5,6,7].map(n => (
                <th key={n} style={{ border: "1px solid black", padding: 5, textAlign: "center" }}>{n}</th>
              ))}
              <th style={{ border: "1px solid black", padding: 5, textAlign: "center" }}>Situations</th>
              <th style={{ border: "1px solid black", padding: 5, textAlign: "center" }}>Comment</th>
            </tr>
          </thead>
          <tbody>
       {symptoms.map((symptom, idx) => {
  const resp = formData.symptomResponses[idx] || {};
  return (
    <tr key={symptom.id}>
      {/* Symptom text */}
      <td
        style={{
          border: "1px solid black",
          padding: 5,
          backgroundColor: "#fff7f7",
        }}
      >
        {symptom.text}
      </td>

      {/* Yes / No checkboxes with dot style */}
      {["N", "Y"].map((val) => (
        <td
          key={val}
          style={{ border: "1px solid #999", textAlign: "center" }}
        >
          <input
            type="checkbox"
            checked={
              (val === "Y" && resp.yesNo === true) ||
              (val === "N" && resp.yesNo === false)
            }
            onChange={() => handleSymptomChange(idx, "yesNo", val === "Y")}
            style={{
              width: "16px",
              height: "16px",
              appearance: "none",
              border: "none",
              borderRadius: "50%",
              cursor: "pointer",
              marginRight:"0",
              backgroundColor:
                (val === "Y" && resp.yesNo === true) ||
                (val === "N" && resp.yesNo === false)
                  ? "#007bff"
                  : "transparent",
            }}
          />

              {shouldPrint && data && resp.yesNo === val && (
            <span style={{ color: "#007bff", fontWeight: "bold", fontSize: "20px" }}>●</span>
          )}

        </td>
      ))}

      {/* Frequency checkboxes 1-7 with dot style */}
      {[1, 2, 3, 4, 5, 6, 7].map((n) => (
        <td
          key={n}
          style={{ border: "1px solid #999", textAlign: "center" }}
        >
          <input
            type="checkbox"
            checked={resp.frequency === n}
            onChange={() => handleSymptomChange(idx, "frequency", n)}
            style={{
              width: "16px",
              height: "16px",
              appearance: "none",
              border: "none",
              borderRadius: "50%",
              cursor: "pointer",
              marginRight:"0",
              backgroundColor: resp.frequency === n ? "#007bff" : "transparent",
            }}
          />
             { shouldPrint && data && resp.frequency === n && (
      <span
        style={{
          color: "#007bff",
          fontWeight: "bold",
          fontSize: "20px",
        }}
      >
        ●
      </span>
    )}
        </td>
      ))}

      {/* Situations input */}
      <td style={{ border: "1px solid #999", textAlign: "center" }}>
        <input
          type="text"
          value={resp.situations || ""}
          onChange={(e) => handleSymptomChange(idx, "situations", e.target.value)}
          style={{
            width: "100%",
            border: "none",
            outline: "none",
            backgroundColor: "#f1effa",
          }}
        />
      </td>

      {/* Comment input */}
      <td style={{ border: "1px solid #999", textAlign: "center" }}>
        <input
          type="text"
          value={resp.comment || ""}
          onChange={(e) => handleSymptomChange(idx, "comment", e.target.value)}
          style={{
            width: "100%",
            border: "none",
            outline: "none",
            backgroundColor: "#f1effa",
          }}
        />
      </td>
    </tr>
  );
})}

          </tbody>
        </table>
      </div>

      {/* Situations List */}
      <div style={{ margin: "20px 0" }}>
        <p style={{ fontSize: 14, marginBottom: 5 }}>
          <strong style={{ fontWeight: "bold", color: "#cc0000" }}>*SITUATIONS:</strong> circumstances under which you experience the above symptoms
        </p>
        <div style={{ display: "flex", flexWrap: "wrap", fontSize: 12 }}>
          {situations.map((situation) => (
            <div key={situation.id} style={{ width: "33%", padding: "3px 0" }}>{situation.text}</div>
          ))}
        </div>
      </div>

      {/* General Comments */}
      <div style={{ margin: "20px 0", display: "flex", alignItems: "center" }}>
        <label style={{ fontWeight: "bold", marginRight: "5px" }}>General comments:</label>
        <input
          type="text"
          value={formData.generalComments}
          onChange={(e) => handleInputChange({ target: { name: "generalComments", value: e.target.value } })}
          style={{ borderBottom: "1px solid black", borderTop: "none", borderLeft: "none", borderRight: "none", flexGrow: 1, height: 30, outline: "none", backgroundColor: "#f1f4ff" }}
        />
      </div>

     {!data &&  <div className="client-submit-btn">
        <button type="button" onClick={handleSubmit}> {loading?t("Submitting..."):t("Submit")}</button>
      </div>}
         <Modal
                                isOpen={successModal}
                                toggle={successToggleModal}
                                className="connect-box"
                                centered={true}
                              >
                                <ModalHeader toggle={successToggleModal}>
                                  <span className="ml-1 roititle font-weight-bold">
                                    Successfull
                                  </span>
                                </ModalHeader>
                                <ModalBody>
                                  <div className="modal-p">
                                    <p>Client form has been submitted successfully.</p>
                                  </div>
                                </ModalBody>
                              </Modal>
    </div>
  );
};

export default BreathingBehaviorsForm;
